import React from 'react';
import InputV1 from '../../../../../components/ComponentsV1/InputV1';

const CategoryDropdown = ({ loading, options, value, onChange }) => {
  return (
    <div className='tw-flex tw-flex-col tw-h-max tw-gap-5 tw-flex-1'>
      <div className='tw-w-full tw-text-grey-900 tw-font-medium tw-text-500'>
        Category <span className='tw-text-red-500'>*</span>
      </div>
      <div className='tw-flex tw-flex-col tw-w-full' style={{ width: '100%' }}>
        <InputV1
          loading={loading}
          options={options || []}
          placeholder='Choose category'
          multiple={false}
          isSearchable
          inputProps={{
            className: 'tw-border-none',
            type: 'text',
            style: { width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
          }}
          style={{ width: '100%', display: 'block' }}
          closeOnSelect
          onSelect={(selectedValue) => {
            onChange(selectedValue ?? null);
          }}
          value={value ? value.value : undefined}
        />
      </div>
    </div>
  );
};

export default CategoryDropdown;
